module.exports = __webpack_public_path__ + "static/media/biscay.9e50a0e0.png";